import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import './styles';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon';
import FamilyCodeBanner from '@/app/main/onboarding/components/FamilyCodeBanner/FamilyCodeBanner';
import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import {COLORS} from '@/styles/colors';
import {formatAppDate} from '@/utils/formatAppDate';
import {formatPhoneNumber} from '@/utils/formatPhoneNumber';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const SummaryInfoPageContent = () => {
  const {t} = useTranslation();
  const {
    kidData,
    selectedTheme,
    isCountryCodeVisible,
    handleEdit,
    handleCreateKid,
    showFamilyCodeBanner,
    handleKidLinked,
  } = useViewModelProvider();
  return (
    <Box className="summary-info-container">
      <Typography className="summary-info-title">
        Please review <span className="your-kid">{kidData.firstName}'s</span>{' '}
        info
      </Typography>
      <Box className="content-container">
        <Box className="card-container">
          <Box
            component="img"
            src={`/assets/images/cards/MoCardMockup-${selectedTheme}.webp`}
            alt={'Mo Card'}
            sx={{
              width: '200px',
            }}
          />
        </Box>
        <Box className="flex justify-between items-center">
          <Typography
            className="text-14"
            color="text.secondary">
            {t('add_kid.summary.name')}
          </Typography>
          <Typography className="text-bold">
            {kidData.firstName} {kidData.lastName}
          </Typography>
        </Box>
        <Box className="flex justify-between items-center">
          <Typography
            className="text-14"
            color="text.secondary">
            {t('add_kid.summary.dob')}
          </Typography>
          <Typography className="text-bold">
            {formatAppDate(kidData.dob)}
          </Typography>
        </Box>
        {kidData?.phone && (
          <Box className="flex justify-between items-center ">
            <Typography
              className="text-14"
              color="text.secondary">
              {t('add_kid.summary.phone')}
            </Typography>
            <Typography className="text-bold">
              {formatPhoneNumber(kidData?.phone, isCountryCodeVisible)}
            </Typography>
          </Box>
        )}
        {kidData?.email && (
          <Box className="flex justify-between items-center">
            <Typography
              className="text-14"
              color="text.secondary">
              {t('add_kid.summary.email')}
            </Typography>
            <Typography className="text-bold">{kidData.email} </Typography>
          </Box>
        )}
        {!!kidData.uuid && (
          <Typography className="text-note">
            {t('add_kid.summary.phone_and_email_not_editable')}
          </Typography>
        )}
        <AppButton
          id="add-kid-summary-edit-button"
          label={t('add_kid.summary.edit')}
          variant={AppButtonVariant.onQuinary}
          onClick={handleEdit}
          iconLeft={
            <FuseSvgIcon
              className="FuseSidePanel-buttonIcon"
              size={16}
              sx={{color: COLORS.ON_SURFACE}}>
              material-twotone:edit
            </FuseSvgIcon>
          }
        />
      </Box>
      {showFamilyCodeBanner && (
        <FamilyCodeBanner
          kidName={kidData?.firstName}
          onKidLinked={handleKidLinked}
          isAddKidLastStep={true}
        />
      )}
      <Box>
        <ButtonContainer sticky>
          <AppButton
            id="add-kid-summary-create-button"
            label={t('add_kid.summary.create')}
            variant={AppButtonVariant.onPrimary}
            onClick={handleCreateKid}
          />
        </ButtonContainer>
      </Box>
    </Box>
  );
};

const SummaryInfoPage = () => (
  <ViewModelProvider>
    <SummaryInfoPageContent />
  </ViewModelProvider>
);

export default SummaryInfoPage;
